<template>
  <div class="service-button-list-parts">
    <ul class="service-button-list-parts__list">
      <li class="service-button-list-parts__item">
        <atom-icon-router-button
          to=""
          colorType="secondary"
          :linkText="$tc('SignupPage.IndexPage.signupWithGoogle')"
          :imgPath="require('@/assets/img/icon/icon_google.svg')"
          iconPosition="left"
          @emitClick="startGoogleOauthFlow"
        />
      </li>
      <li v-if="isiOS" class="service-button-list-parts__item">
        <atom-icon-router-button
          to=""
          colorType="secondary"
          :linkText="$tc('SignupPage.IndexPage.signupWithApple')"
          :imgPath="require('@/assets/img/icon/icon_apple.svg')"
          iconPosition="left"
          @emitClick="onStartAppleOauthFlow"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomIconRouterButton from '@/components/atoms/AtomIconRouterButton.vue'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'ServiceButtonListParts',
  components: { AtomIconRouterButton },
  setup() {
    const isiOS = DeviceInfo.isiOS()

    return {
      isiOS,
    }
  },
  methods: {
    /**
     * Googleの認可を開始する
     */
    startGoogleOauthFlow() {
      this.$emit('onStartGoogleOauthFlow')
    },
    /**
     * Appleの認可を開始する
     */
    onStartAppleOauthFlow() {
      this.$emit('onStartAppleOauthFlow')
    },
  },
})
</script>

<style scoped lang="scss">
.service-button-list-parts {
  &__item {
    + .service-button-list-parts__item {
      margin-top: 6px;
    }

    ::v-deep {
      span {
        padding-top: 2px;
      }
    }
  }
}
</style>
